module.exports = "pegasus/assets/theme3/small/3.jpg";